import { createSvgIcon } from "@mui/material/utils";

export const DashboardMenuIcon = createSvgIcon(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H9.08984V9.08984H0V0ZM0 10.9102H9.08984V20H0V10.9102ZM10.9102 0H20V9.08984H10.9102V0ZM10.9102 20V10.9102H20V20H10.9102Z" fill="white"/>
    </svg>,
  "Dashboard"
);